module.exports = __webpack_public_path__ + "img/icon-warning_2.0d40a957.svg";